import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "polling", payment_status: null, lookup_key: null });

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setState({ status: "paid", payment_status: data.payment_status, lookup_key: data.lookup_key });
          return;
        }
        if (data.payment_status === "failed" || data.payment_status === "expired") {
          setState({ status: "failed", payment_status: data.payment_status, lookup_key: data.lookup_key });
          return;
        }
        attempts++;
        if (attempts > 15) {
          setState({ status: "timeout", payment_status: data.payment_status, lookup_key: data.lookup_key });
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        if (!cancelled) setState((s) => ({ ...s, status: "error" }));
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#f3f3f1] flex items-center justify-center p-6">
      <div data-testid="payment-success-card" className="w-full max-w-md bg-white rounded-2xl p-8 shadow-sm text-center">
        {state.status === "polling" && (
          <>
            <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-[#1a1a1a]" />
            <h1 className="font-display text-2xl mb-2">Even geduld…</h1>
            <p className="text-sm text-gray-500">We bevestigen je betaling.</p>
          </>
        )}
        {state.status === "paid" && (
          <>
            <CheckCircle2 className="w-10 h-10 text-emerald-600 mx-auto mb-4" />
            <h1 className="font-display text-3xl mb-2">Bedankt!</h1>
            <p className="text-sm text-gray-600 mb-6">
              {state.lookup_key === "brand_pro_monthly"
                ? "Je Pro-abonnement is actief. Writer en Creator zijn nu onbeperkt beschikbaar."
                : "50 AI-credits zijn toegevoegd aan dit merk."}
            </p>
            <Link to="/"><Button className="rounded-full bg-[#1a1a1a] text-white hover:bg-black/90">Terug naar dashboard</Button></Link>
          </>
        )}
        {(state.status === "failed" || state.status === "error") && (
          <>
            <h1 className="font-display text-2xl mb-2">Betaling niet gelukt</h1>
            <p className="text-sm text-gray-500 mb-6">Probeer het opnieuw of neem contact op met support.</p>
            <Link to="/"><Button className="rounded-full">Terug</Button></Link>
          </>
        )}
        {state.status === "timeout" && (
          <>
            <h1 className="font-display text-2xl mb-2">Even wachten</h1>
            <p className="text-sm text-gray-500 mb-6">Je betaling wordt nog verwerkt. Ververs deze pagina later of ga terug naar het dashboard.</p>
            <Link to="/"><Button className="rounded-full">Terug</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
